export default "__VITE_ASSET__37k6Elhd__"